<template>
  <div class="news-details">
    <banner title="新闻详情" img="../assets/img/bgtop.jpg" />
    <div class="news-details-section" v-loading="loading">
      <article class="news-details-content">
        <router-link class="back-link" to="/news">
          <i class="el-icon-back"></i>
          <span>返回新闻资讯</span>
        </router-link>

        <div class="article-head">
          <span class="article-label">News</span>
          <h1>{{ newsTitle }}</h1>
          <div class="article-meta">
            <span><i class="el-icon-time"></i>{{ newsIdList.createTime }}</span>
            <span><i class="el-icon-office-building"></i>华欣焱科技</span>
          </div>
        </div>

        <img
          class="article-cover"
          v-if="newsIdList.img"
          v-lazy="imgserver + newsIdList.img"
          :alt="newsTitle"
        />

        <div class="article-body" v-html="newsIdList.content"></div>
      </article>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      loading: true,
      newsIdList: {}
    };
  },
  computed: {
    newsTitle() {
      return this.newsIdList.title || this.newsIdList.Title || "新闻详情";
    }
  },
  created() {
    this.pid = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/${this.pid}`)
        .then(response => {
          this.newsIdList = response.result || {};
        })
        .catch(error => {
          window.console.log(error);
          this.newsIdList = {};
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.news-details {
  width: 100%;
  min-height: 100%;
  background: linear-gradient(180deg, #eef5fb 0%, #f8fafc 56%, #eef4f8 100%);

  &-section {
    width: 100%;
    padding: 0 0 64px;
  }

  &-content {
    width: min(980px, 92%);
    margin: -34px auto 0;
    padding: 42px 70px 64px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
    position: relative;
    z-index: 2;
  }
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  color: #156da8;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.25s ease;

  &:hover {
    color: #d63a30;
  }
}

.article-head {
  margin-top: 24px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e5edf4;

  .article-label {
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: 0 12px;
    border-radius: 999px;
    background: rgba(214, 58, 48, 0.08);
    color: #d63a30;
    font-size: 13px;
    font-weight: 700;
  }

  h1 {
    margin-top: 16px;
    color: #142235;
    font-size: 36px;
    line-height: 1.35;
    font-weight: 700;
  }

  .article-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    margin-top: 16px;
    color: #7d8fa3;
    font-size: 14px;

    span {
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }
  }
}

.article-cover {
  display: block;
  width: 100%;
  max-height: 480px;
  object-fit: cover;
  margin-top: 32px;
  border-radius: 8px;
  background: #dbe8f1;
}

.article-body {
  margin-top: 34px;
  color: #33465c;
  font-size: 17px;
  line-height: 1.9;
  word-break: break-word;

  p {
    margin: 0 0 16px;
  }
}

@media (max-width: 760px) {
  .news-details-content {
    width: 94%;
    padding: 30px 20px 44px;
  }

  .article-head h1 {
    font-size: 28px;
  }

  .article-body {
    font-size: 16px;
  }
}
</style>
